export enum ShiftHandoverStatusEnum {
  DRAFT = "draft",
  SUBMITTED = "submitted",
}
